module.exports = "<p class=\"status-message\"><slot></slot></p>\n"